import React from 'react';

function RouletteWheel3color({
  width = 900,
  height = 900,
  viewBox = '-370 248.3 100 100',
  className = 'shape',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id="Gradient2" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path fill="url(#Gradient2)" d="M-274.8 305.4c0-10.1-17.5-18.4-39.9-19.3v.3l.3 2c11.8.7 21.9 3.6 27.4 7.7 2.9 2.2 4.6 4.6 4.6 7.3 0 1.1-.3 2.1-.8 3.1-.8 1.5-2.1 2.9-3.9 4.2-6.3 4.6-18.4 7.7-32.3 7.7s-26-3.1-32.3-7.7c-1.8-1.3-3.1-2.7-3.9-4.2-.5-1-.8-2.1-.8-3.1 0-2.1 1.1-4.1 3-6 5-4.8 15.9-8.3 29-9l.3-2.2c-21.6 1.2-38.4 9.3-38.4 19.2 0 .5.1 1 .1 1.5.2 1.3.7 2.5 1.5 3.7 0 0 0 .1.1.1 5.2 8.1 22.1 14 42.1 14 15.3 0 28.7-3.4 36.5-8.7-7.4 6.6-22.2 11-39.3 11-19.1 0-35.3-5.6-41.5-13.4 2.3 11.2 21.1 19.9 43.9 19.9 24.4 0 44.2-9.9 44.2-22.2v-4.9h-.1c.2-.2.2-.6.2-1z" />
      <path fill="url(#Gradient2)" d="M-289.3 301.2c-1.7 0-3.2 1.4-3.2 3.2 0 .9.3 1.6.9 2.2.6.6 1.4 1 2.3 1s1.7-.4 2.3-1c.6-.6.9-1.3.9-2.2 0-1.8-1.4-3.2-3.2-3.2zM-313.9 291.1l1.5 10.4c0 2.2-5.7 3.3-6.9 3.3-1.2 0-6.9-1.1-6.9-3.2l1.5-10.5c-10.7 1-18.7 5-18.7 9.7 0 2.1 1.6 4.1 4.4 5.7 4.4 2.5 11.6 4.2 19.7 4.2s15.3-1.7 19.7-4.2c2.8-1.6 4.4-3.6 4.4-5.7 0-4.7-8-8.7-18.7-9.7z" />
      <path fill="url(#Gradient2)" d="M-334.1 284.5c1 0 1.8-.4 2.5-1h9l-.4 2.7-.3 2.2-.1.9-.3 1.8-1.5 10.7c0 .8 4.1 2.1 5.9 2.1 1.8 0 5.9-1.3 5.9-2.2l-1.5-10.6-.3-1.8-.1-.9-.3-2v-.2l-.4-2.6h10c.7.6 1.5 1 2.5 1 2 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7c-1 0-1.8.4-2.5 1h-10.8l-.2-1.4c.2-.1.3-.1.5-.2s.3-.1.5-.2c2.3-1.2 3.8-3.5 3.8-6.3 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 2.7 1.6 5.1 3.8 6.3.2.1.3.2.5.2.2.1.3.1.5.2l-.2 1.4h-9.8c-.7-.6-1.5-1-2.5-1-2 0-3.7 1.7-3.7 3.7 0 1.9 1.7 3.6 3.7 3.6zm19.4-15.1s-.4-.9-2.1-2.4c-.9-.9-2.5-1.8-2.5-1.8 4.5.2 4.6 4.2 4.6 4.2z" />
    </svg>
  );
}

export default RouletteWheel3color;
